import React, { useEffect, useState } from "react";
import { Route, Router, Routes, useLocation } from "react-router-dom";
import Navbar from "../Components/include/Navbar";
import Home from "../Pages/Home";
import Footer from "../Components/include/Footer";
import About from "../Pages/About";
import ContactUs from "../Pages/ContactUs";
import News from "../Pages/News";
import NewsDetail from "../Pages/NewsDetail";
import ExtracurricularList from "../Pages/ExtracurricularList";
import ExtracurricularDetails from "../Pages/ExtracurricularDetails";
import Department from "../Pages/Department";
import DepartmentDetails from "../Pages/DepartmentDetails";
import Education from "../Pages/Education";
import ViewFacilities from "../Pages/Education/ViewFacilities";
import TermsConditions from "../Pages/TermsConditions";
import ViewProjects from "../Pages/Education/ViewProjects";
import Policies from "../Pages/Policies";
import Newsletter from "../Components/Newsletter";
import FAQ from "../Components/FAQ";
import { Getdata } from "../helpers/api.service";
import AdmissionDetails from "../Pages/AdmissionDetails";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const Allroutes = () => {
  const [data, setData] = useState(null);
  const fetchData = () => {
            // setLoading(true);
            Getdata(
              process.env.REACT_APP_URL +
                `/front/profile/${process.env.REACT_APP_SUBDOMAIN}`
            )
              .then((res) => {
                console.log("Profile API response:", res);
                if (res?.data) {
                  setData(res.data);
                }
                // setImages(res.data.map((item) => item.image));
                // setLoading(false);
              })
              .catch((err) => {
                console.error("Error fetching FAQ:", err);
                // setLoading(false);
              });
    };
        
    useEffect(() => {
      fetchData();
    }, []);
    
  return (
    <>
      <Navbar data={data} />
      <ScrollToTop />
      <div className="pt-[85px]">
        <Routes>
          <Route path="/" element={<Home data={data} />} />
          <Route path="/about" element={<About data={data} />} />
          <Route path="/contact" element={<ContactUs data={data} />} />
          <Route path="/admission-details" element={<AdmissionDetails/>} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:title" element={<NewsDetail />} />
          <Route
            path="/extra-curricular/:title"
            element={<ExtracurricularList />}
          />
          <Route
            path="/extra-curricular-details/:title"
            element={<ExtracurricularDetails />}
          />
          <Route path="/education" element={<Education />} />
          <Route
            path="/education/facilities/view/:name"
            element={<ViewFacilities />}
          />
          <Route
            path="/education/projects/view/:title"
            element={<ViewProjects />}
          />
          <Route
            path="/departments"
            element={<Department />}
          />
          <Route
            path="/department-details/:title"
            element={<DepartmentDetails />}
          />
          {/* <Route path="/terms-conditions" element={<TermsConditions />} /> */}
          <Route path="/others/:id" element={<Policies />} />
        </Routes>
      </div>
      <Newsletter />
      <FAQ />
      <Footer data={data} />
       <div className="text-center text-sm  bg-white">
        <p className="text-gray-600 p-2 text-bold">
         <b>Copyright {new Date().getFullYear()} {data?.name}. All rights reserved</b>
        </p>
      </div>
    </>
  );
};

export default Allroutes;
